import { render, staticRenderFns } from "./VuseColorPicker.vue?vue&type=template&id=f6e3bed6"
import script from "./VuseColorPicker.vue?vue&type=script&lang=js"
export * from "./VuseColorPicker.vue?vue&type=script&lang=js"
import style0 from "./VuseColorPicker.vue?vue&type=style&index=0&id=f6e3bed6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports